<template>
  <div class="wrapper">
    <div class="terms-wrap">
      <div class="terms" @click="downloadTos('privacy')">
        <div class="text">
          <div class="tos-name">개인정보 취급 방침</div>
          <div class="date">
            <span class="color-blue">최근개정일</span>2023-04-28
          </div>
        </div>
        <div class="btn">
          <img src="@/assets/img/ic_download_terms.svg" />
        </div>
      </div>
      <div class="terms" @click="downloadTos('tos-client')">
        <div class="text">
          <div class="tos-name">서비스 이용약관 (고객용)</div>
          <div class="date">
            <span class="color-blue">최근개정일</span>2022-02-28
          </div>
        </div>
        <div class="btn">
          <img src="@/assets/img/ic_download_terms.svg" />
        </div>
      </div>
      <div class="terms" @click="downloadTos('tos-rider')">
        <div class="text">
          <div class="tos-name">서비스 이용약관 (배송원용)</div>
          <div class="date">
            <span class="color-blue">최근개정일</span>2021-11-29
          </div>
        </div>
        <div class="btn">
          <img src="@/assets/img/ic_download_terms.svg" />
        </div>
      </div>
      <div class="terms" @click="downloadTos('lbs')">
        <div class="text">
          <div class="tos-name">위치기반 서비스 이용약관</div>
          <div class="date">
            <span class="color-blue">최근개정일</span>2019-09-01
          </div>
        </div>
        <div class="btn">
          <img src="@/assets/img/ic_download_terms.svg" />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  metaInfo: {
    title: "이용약관"
  },
  methods: {
    downloadTos(type) {
      if (type === "privacy") {
        window.open(
          "https://static.dver.co.kr/privacy-terms/latest.pdf ",
          "_blank"
        );
      }
      if (type === "tos-client") {
        window.open(
          "https://static.dver.co.kr/service-terms-customers.pdf",
          "_blank"
        );
      }
      if (type === "tos-rider") {
        window.open("https://static.dver.co.kr/tos/partners.pdf", "_blank");
      }
      if (type === "lbs") {
        window.open(
          "https://static.dver.co.kr/location-terms/latest.pdf",
          "_blank"
        );
      }
    }
  }
};
</script>
<style src="./index.css" scoped></style>
